import { Link } from 'react-router-dom';
import { footerContent } from '@/mocks/home';

const LOGO_URL = 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/6779162182ed6d3a577de7e05a94991c.png';

export default function Footer() {
  return (
    <footer className="bg-background-50 border-t border-background-200/50">
      {/* Main footer */}
      <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 py-12 md:py-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Logo / Brand */}
          <div>
            <Link to="/" className="inline-flex items-center gap-2.5">
              <img src={LOGO_URL} alt="析莜科技" className="h-8 w-auto" />
              <div className="flex flex-col leading-none">
                <span className="text-base font-bold font-heading text-foreground-50">
                  析莜科技
                </span>
                <span className="text-[9px] tracking-[0.15em] font-label uppercase text-foreground-300">
                  XIYOOTECHNOLOGY
                </span>
              </div>
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              析莜信息科技(XIYOOTECHNOLOGY)是一家专注于网银AI智管平台、企业数字化转型及信息安全硬件的综合科技企业
            </p>
          </div>

          {/* Columns */}
          {footerContent.columns.map((col, colIndex) => (
            <div key={colIndex}>
              <h4 className="text-base font-semibold text-foreground-100 mb-4">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {'links' in col
                  ? col.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        <span className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-default">
                          {link}
                        </span>
                      </li>
                    ))
                  : 'items' in col
                    ? (col as { items: string[] }).items.map((item, itemIndex) => (
                        <li key={itemIndex}>
                          <span className="text-sm text-foreground-400">
                            {item}
                          </span>
                        </li>
                      ))
                    : null}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-200/30">
        <div className="w-full px-4 md:px-8 lg:px-12 py-5 max-w-[1400px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>{footerContent.copyright}</p>
          <a
            href={footerContent.icpHref}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground-300 transition-colors"
          >
            {footerContent.icp}
          </a>
        </div>
      </div>
    </footer>
  );
}